import {
  DownloadableAppLocale,
  LocalizedList,
  LocalizedText
} from 'shared/api/containerApi'

// i18next.language can be a region-qualified tag (e.g. "en-US"); the backend
// only knows the bare language codes in DownloadableAppLocale.
const toLocale = (language: string): DownloadableAppLocale =>
  language?.split('-')[0] as DownloadableAppLocale

// Picks the best available translation for the current UI language: the
// exact language, then English, then whatever locale happens to be set
// (an app might only have e.g. German filled in), then ''/[].
export const pickLocalizedText = (
  value: LocalizedText | undefined,
  language: string
): string => {
  if (!value) return ''
  const locale = toLocale(language)
  return value[locale] || value.en || Object.values(value)[0] || ''
}

export const pickLocalizedList = (
  value: LocalizedList | undefined,
  language: string
): string[] => {
  if (!value) return []
  const locale = toLocale(language)
  return value[locale] || value.en || Object.values(value)[0] || []
}
